module.exports = __webpack_public_path__ + "static/image/login_bg.9b0a528567b30e3b8c3e6860bde74c1f.jpg";